<div class="overview-section">
  <div class="overview-shell">
    <p class="overview-label">Your Books, At a Glance</p>
    <h2 class="overview-heading">One Dashboard for Every Number</h2>

    <div class="overview-layout">
      <div class="overview-stats">
        <div class="stat-pull">
          <span class="stat-num">179</span>
          <span class="stat-label">Chart of accounts, ready to use from day one</span>
        </div>
        <div class="stat-pull">
          <span class="stat-num">100%</span>
          <span class="stat-label">Entries checked for debit/credit balance before posting</span>
        </div>
        <div class="stat-pull">
          <span class="stat-num">1</span>
          <span class="stat-label">Click to move an entry from draft to posted</span>
        </div>
      </div>

      <div class="overview-browser">
        <div class="browser-bar">
          <span class="browser-dot browser-dot--red"></span>
          <span class="browser-dot browser-dot--yellow"></span>
          <span class="browser-dot browser-dot--green"></span>
        </div>
        <img src="images/modules/accounting-overview.PNG" alt="orderYaa Accounting Overview dashboard showing posted entries, drafts, and chart of accounts" />
      </div>
    </div>
  </div>
</div>
